import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const HalalInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">GMP </span>GET
              CERTIFICATION MUMBAI
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            Halal certification is a process that verifies that a product or
            service complies with Islamic law and is acceptable for consumption
            by Muslims.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Halal certification is a process that verifies that a product or
            service complies with Islamic law and is acceptable for consumption
            by Muslims.
          </p>

          {/* how its works  */}
          <p className="font-bold text-xl text-[#4D4D4D] py-2">How its works</p>

          <ol className="list-decimal ml-5 text-xs md:text-lg text-[#4D4D4D]">
            <li>Private organizations in India perform halal certification</li>
            <li className="py-2">
              Some of these organizations are recognized by the Indian
              government
            </li>
            <li>
              Businesses must comply with the certification body’s guidelines
              and pass an inspection and audit{" "}
            </li>
          </ol>

          {/* why its important  */}
          <p className="font-bold text-xl text-[#4D4D4D] py-4">
            Why it’s important{" "}
          </p>

          <ol className="list-decimal ml-5 text-xs md:text-lg text-[#4D4D4D]">
            <li>
              Halal certification ensures that products are safe, hygienic, and
              do not contain forbidden ingredients
            </li>
            <li className="py-2">
              It also helps companies access the growing global market
            </li>
            <li>It can enhance a brand’s reputation</li>
          </ol>

          {/* What it applies to  */}
          <p className="font-bold text-xl text-[#4D4D4D] py-4">
            What it applies to{" "}
          </p>

          <ol className="list-decimal ml-5 text-xs md:text-lg text-[#4D4D4D]">
            <li>
              Food, beverages, pharmaceuticals, personal care products,
              cosmetics, and more
            </li>
            <li className="py-2">
              Restaurants, hotels, and slaughtering houses
            </li>
            <li>Packaging and labeling materials</li>
          </ol>

          {/* In India  */}
          <p className="font-bold text-xl text-[#4D4D4D] py-4">In India</p>

          <ol className="list-decimal ml-5 text-xs md:text-lg text-[#4D4D4D]">
            <li>The Indian government doesn’t mandate halal certification</li>
            <li className="py-2">
              The Food Safety and Standard Authority of India (FSSAI) certifies
              edible products
            </li>
            <li>
              Halal certification is not required to export or import products
            </li>
          </ol>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default HalalInfoContainer;
